
import {Dataset,AssertUtils} from "goingutils";
import dhtmlXGridObject from '../dhtmlXGridObject';

function eXcell_ch(a) {

    let cellObj = this;
    if (a) {
        cellObj.cell = a;
        cellObj.grid = cellObj.cell.parentNode.grid;
        var idd = cellObj.cell.parentNode.idd;
        cellObj.grid.removeErrorVali(idd);
        cellObj.grid.deleteRow(idd);
    }
}

//重写checkbox列
eXcell_ch.prototype.setValue = function(c) {
    this.cell.style.verticalAlign = "middle";
    if (c) {
        c = c.toString()._dhx_trim();
        if (c == "false" || c == "0") {
            c = "";
        }
    }
    if (c) {
        c = "1";
        this.cell.chstate = "1";
    } else {
        c = "0";
        this.cell.chstate = "0";
    }

    this.cell.setAttribute("excell", "ch");
    var g = this.cell.parentNode.idd;
    if (g != null && (g + "").indexOf("newId_") >= 0) {
        this.setCValue(`<i class="ivu-icon ivu-icon-md-remove-circle-outline" onclick='eXcell_Remove(this.parentNode); (arguments[0]||event).cancelBubble=true; ' style="font-size: 18px;cursor: pointer;"></i>`,
            this.cell.chstate
        );
    } else {
        this.setCValue(
            "<img src='" +
            this.grid.imgURL +
            "item_chk" +
            c +".gif' onclick='new eXcell_ch(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '>",
            this.cell.chstate
        );
    }
};
//删除编辑表格的错误校验信息

dhtmlXGridObject.prototype.removeErrorVali = function(rowId) {
    $(".errorIcon").each(function(index, itemObj) {
        if (($(itemObj).attr("id") + "").indexOf(rowId) >= 0) {
            $(itemObj).remove();
            $("#" + $(itemObj).attr("id") + "_tip").remove();
        }
    });
};
//根据单元格的序号 获取对应的cellId
dhtmlXGridObject.prototype.getCellIdByIndex = function(colIndex) {
    if (this.colOrderNum) {
        --colIndex;
    }
    if (this.colSelBox) {
        --colIndex;
    }
    return this.queryFieldAry[colIndex];
};
//获取表格发生过变更的数据
dhtmlXGridObject.prototype.getChangeSubmitData = function() {
    //清除错误标志
    $("#" + this.entBox.id + " .errorIcon").remove();
    //再获取相应的值
    var ids = this.getChangedRows(true).split(",");
    var jsonRecords = [];
    var gridObj = this;
    for (var num = 0; num < ids.length; num++) {
        var rowRecord = {};
        var rowId = ids[num];
        rowRecord["id"] = rowId;
        this.forEachCell(rowId, function(cellObj, ind) {
            if (
                gridObj.getCellIdByIndex(ind) != null &&
                gridObj.getCellIdByIndex(ind) !== "id"
            ) {
                //获取每个单元格的值
                rowRecord[gridObj.getCellIdByIndex(ind)] = cellObj.getValue();
            }
        });
        jsonRecords.push(rowRecord);
    }

    if ($ != null && $.toJSON != null) {

        return $.toJSON(jsonRecords);
    } else {
        return jsonRecords;
    }
};
/**
 * 获取单元格的缺省值
 */
dhtmlXGridObject.prototype.getDefCellValues = function() {
    return this.defValues;
};
dhtmlXGridObject.prototype.getEditorTableDataset = function() {
    var dataset = new Dataset();
    var gridTable = this;
    dataset.setPropNames(gridTable.queryFieldAry);
    var properValues = new Array();
    //清除错误标志
    $("#" + this.entBox.id + " .errorIcon").remove();
    //再获取相应的值
    var ids = this.getChangedRows(true).split(",");
    var gridObj = this;
    for (var num = 0; num < ids.length; num++) {
        var rowId = ids[num];
        if (!AssertUtils.isNotEmpty(rowId)) {
            continue;
        }
        var rowRecord = [];
        let propTypes = [];
        this.forEachCell(rowId, function(cellObj, ind) {
            if (
                gridObj.getCellIdByIndex(ind) != null &&
                gridObj.getCellIdByIndex(ind) !== "id"
            ) {
                //获取每个单元格的值
                rowRecord[ind] = cellObj.getValue();
            }
            if (gridObj.getCellIdByIndex(ind) === "id") {
                rowRecord[ind] = rowId;
            }
            propTypes[ind] = "string";
        });

        if (gridObj.colSelBox) {
            rowRecord.shift();
            propTypes.shift();
        }
        if (gridObj.colOrderNum) {
            rowRecord.shift();
            propTypes.shift();
        }
        properValues.push(rowRecord);
        if (num == 0) {
            dataset.setPropTypes(propTypes);
        }
    }
    dataset.setPropValues(properValues);
    return dataset;
};
//添加行
dhtmlXGridObject.prototype.addNewRow = function(id, data) {
    var rowId = "newId_" + id;
    this.addRow(rowId, data);
    this.selectRowById(rowId);
    var elObj = $("#" + this.entBox.id)
        .find(".rowselected")
        .find("td[excell!='ch']")
        .get(0);
    var gridObj = this;

    $("#" + this.entBox.id)
        .find(".rowselected td")
        .each(function(index, item) {
            if (item == elObj) {
                var cellObj = gridObj.cells(rowId, index);
                if (cellObj != null) {
                    try {
                        gridObj.doClick(cellObj.cell, true, 0, false);
                        gridObj.autoClick = true;
                        gridObj.cell = cellObj.cell;
                        gridObj.editCell();
                    } catch (ex) {
                        console.log(ex, "====ex========");
                    }
                }
            }
        });
};
var __colTypeMapping = {checkbox: "ch", date10: "dhxCalendar"};

/**
 * 添加编辑工具栏
 */
dhtmlXGridObject.prototype.addEditorToolBar=function(){
    if(this._editorToolBar==null){
        $(`<div class="grid_tool_bar" style="position: absolute; width: 16px; visibility: visible; top: 16px; left:4px;" name="img">
                        <div>
                            <span class="addImg btn_icon  icon goingicon iconadd-box" title="复制一行" style="display: block;"></span>
                        </div>
                        <div>
                            <span  class="addEmptyImg btn_icon icon goingicon iconicon-checkboxmarked" title="增加空行" style="display: block;"></span>
                        </div>
                        <div>
                             <span  class="delImg btn_icon icon goingicon iconremove_square" title="删除此行" style="display: block;"></span>
                             <span class="delAllImg btn_icon icon goingicon icondel" style="display:block" title="删除全部"></span>
                        </div>
                        </div>`).appendTo($(`#${this.gridId}`));
        this._editorToolBar=$(`#${this.gridId} .grid_tool_bar`).get(0);
        this.editorToolEvent();
    }
}
/**
 * 添加工具栏相应事件
 */
dhtmlXGridObject.prototype.editorToolEvent=function(){
    let gridObj=this;
    //复制添加
    $(this._editorToolBar).find(".addImg").click(function(){
        let newId=gridObj.uid();let oldId=gridObj.getSelectedRowId();   let rowIndex=gridObj.getRowIndex(oldId);
        gridObj.addRow(newId,[],rowIndex+1);
        gridObj.copyRowContent(oldId,newId);
        gridObj._initColOrderNum();
    });
    //添加空白空
    $(this._editorToolBar).find(".addEmptyImg").click(function(){
        let newId=gridObj.uid();let oldId=gridObj.getSelectedRowId();   let rowIndex=gridObj.getRowIndex(oldId);
        gridObj.addRow(newId,[],rowIndex+1);
        gridObj._initColOrderNum();
    });
    //删除此行
    $(this._editorToolBar).find(".delImg").click(function(){
        let oldId=gridObj.getSelectedRowId();
        gridObj.deleteRow(oldId);
        $(gridObj._editorToolBar).hide();
        gridObj._initEditorData();
        gridObj._initColOrderNum();
    });
    //删除全部行
    $(this._editorToolBar).find(".delAllImg").click(function(){
        gridObj.clearAll();
        $(gridObj._editorToolBar).hide();
        gridObj._initEditorData();
        gridObj._initColOrderNum();
    });
}
//重新初始化序号
dhtmlXGridObject.prototype._initColOrderNum = function () {
    let myGrid = this;
    let num=0;
    myGrid.forEachRow(function (id) {
        myGrid.cells(id,0).setValue(++num);
    });
};
//初始化编辑器
dhtmlXGridObject.prototype._initEditorData = function() {
    let count=this.getRowsNum();
    if(count===0){
        this.addRow(this.uid(),[]);
    }
};
//初始化编辑器
dhtmlXGridObject.prototype.initEditorCtl = function(myGrid,config) {
    function _getElementPosition(el){
        let pos = [el.offsetLeft, el.offsetTop];
        return {x: pos[0], y: pos[1]};
    }

    //点击表格空白处
    myGrid.attachEvent("onEmptyClick", function() {
        myGrid.editStop();
    });

    if(config.editorToolBar){
        myGrid.attachEvent("onRowSelect", ()=>{
            this.addEditorToolBar();
            $(this._editorToolBar).show();
            let pos=_getElementPosition($(`#${this.gridId} .rowselected`).get(0));
            $(this._editorToolBar).css("top",pos["y"]+18);
        });
    }

};
/**
 * 获取数据的编辑类型
 * @param colType
 */
dhtmlXGridObject.prototype.getEditorType = function(colType) {
    if (AssertUtils.isNotEmpty((__colTypeMapping)[colType])) {
        return(__colTypeMapping)[colType];
    } else {
        return colType;
    }
};
//初始化单元格初始值
dhtmlXGridObject.prototype.initDefaultValues = function(itemObj) {
    var gridObj = this;
    if (
        this.getEditorType(itemObj["type"]) === "ch" ||
        this.getEditorType(itemObj["type"]) === "ra"
    ) {
        gridObj.defValues.push(false);
    } else {
        var {defVal = ""} = itemObj;
        gridObj.defValues.push(defVal);
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/extend/dxGridEditorExtend.js